<!--主文件-->
<template>
    <div v-title :data-title="`动态 - 足趣社区`" class="main" v-loading="loading">
        <Header :onDownClick="openApp"/>
        <LiveContent v-if="data" v-title :data-title="`直播 - 足趣社区`" :data="data" :onDownClick="openApp"/>
        <Footer/>
    </div>
</template>

<script>
import Header from '../../../components/Header';
import OpenInstall from "../../../lib/OpenInstall";
import Footer from '../../../components/Footer.vue';
import LiveContent from "./Content.vue";

export default {
    name: "ShareDynamic",
    components: {
        Header,
        Footer,
        LiveContent,
    },
    data: function () {
        return {
            // 动态数据
            data: undefined,
            // 评论数据
            comments: undefined,
            // 动态是否正在加载中
            loading: true,
            // 评论是否正在加载中
            commentLoading: true,
            // shareInstall组件
            shareInstall: undefined,
        }
    },
    created: function () {
        // 先尝试拉起
        OpenInstall.schemeWakeup();

        // 查询直播信息
        this.$axios.post(`/api/live/live/live/get/${this.$route.query.id}`).then((res) => {
            this.loading = false;
            if (res.code !== 200) {
                return;
            }
            this.data = res.data;
        });
    },
    methods: {
        // 打开App
        openApp() {
            this.$router.push({path: "/open", query: this.$route.query});
        },
    }
}
</script>

<style scoped>
.main {
    width: 100%;
    height: 100%;
    font-size: 12px;
    font-family: "Microsoft Yahei", arial, "Hiragino Sans GB", sans-serif;
    max-width: 500px;
    margin: auto;
}

.content {
    padding: 1rem;
}

.content img {
    width: 100%;
    height: 100%;
}

</style>
